import React, { useState, useEffect, useRef } from 'react';
import CTAKnap, { CTAIkoner } from './ctaknap';
import './styles/testimonials.css';

const Testimonials = ({ hideOmOsButton = false, customSecondButton = null, hideCasesButton = false, alternativeCasesButton = null, className = '' }) => {
  const trackRef = useRef(null);
  // Rigtige testimonials fra Trustpilot
  const testimonials = [
    {
      id: 1,
      name: "Nikolaj Moestrup",
      company: "Sjow Media",
      text: "Parla Branding er AMAZING! Nicolai har været fantastisk til at skabe vores visioner. Nem at arbejde med!",
      rating: 5
    },
    {
      id: 2,
      name: "Rasmus Nordström",
      company: "Griner'n",
      text: "Parla og Mark ramte den lige i rumpetten. Helt igennem behagelig oplevelse og kæmpe service!",
      rating: 5
    },
    {
      id: 3,
      name: "Louise Munk",
      company: "Psykolog Louise Munk",
      text: "Jeg fik lavet min hjemmeside og den er blevet virkelig god! Kan gerne anbefale dem.",
      rating: 4
    },
    {
      id: 4,
      name: "Svend Klingberg",
      company: "RelationsPsykologerne",
      text: "Enormt imødekommende og servicemindede mennesker. Hjælpsomme, effektive og ordentlige.",
      rating: 5
    },
    {
      id: 5,
      name: "Charlotte Hagmund-Hansen",
      company: "Psykolog Hagmund",
      text: "Personlig kontakt, lydhørighed, fleksibilitet, ordentlighed. Har kun gode oplevelser.",
      rating: 5
    },
    {
      id: 6,
      name: "Karoline Debois",
      company: "Lyngby Psykologen",
      text: "Mark og Nicolai reddede mig på målstregen under stort tidspres. Supersøde og dygtige!",
      rating: 5
    },
    {
      id: 7,
      name: "Heidi Rømer",
      company: "Psykologisk Info",
      text: "Supergodt forløb! De bruger ikke standardskabeloner. Troværdige og engagerede unge mennesker!",
      rating: 5
    },
    {
      id: 8,
      name: "Alexander Hansen",
      company: "Privat kunde",
      text: "Flinke gutter, gode til at hjælpe og forklare. Kan varmt anbefales!",
      rating: 5
    },
    {
      id: 9,
      name: "Kristina",
      company: "Upcare",
      text: "Parla Branding er fantastiske at arbejde med! Ambitiøse, energiske og meget dygtige.",
      rating: 5
    },
    {
      id: 10,
      name: "Lone Frederiksen",
      company: "Byggeriets Partner",
      text: "Her får I min varmeste anbefaling! Parla Branding leverer kvalitet på højeste niveau.",
      rating: 5
    },
    {
      id: 11,
      name: "Oskar",
      company: "CBS AI",
      text: "Jeg kan kun sige at jeg er super tilfreds med den oplevelse jeg fik fra Parla Branding.",
      rating: 5
    },
    {
      id: 12,
      name: "Rasmus Revsbech",
      company: "Psykudredning",
      text: "Parla branding har på alle måder hjulpet min lille virksomhed psykudredning.dk med at få et professionelt og skarpt brand. De er en fornøjelse at arbejde med, og de gør sig enormt umage.",
      rating: 5
    }
  ];

  // Dublér testimonials for seamless loop
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  // Smooth continuous scroll effect
  useEffect(() => {
    if (!trackRef.current) return;

    let animationId;
    let currentX = 0;
    const speed = 0.15; // pixels per frame (much slower animation)
    
    const animate = () => {
      if (trackRef.current) {
        currentX -= speed;
        
        // Get the width of one complete set of testimonials
        const cardWidth = 320 + 24; // card width + gap
        const oneSetWidth = testimonials.length * cardWidth;
        
        // Reset when we've scrolled one complete set
        if (Math.abs(currentX) >= oneSetWidth) {
          currentX = 0;
        }
        
        trackRef.current.style.transform = `translateX(${currentX}px)`;
      }
      
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [testimonials.length]);

  // Schema markup for testimonials
  const testimonialsSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Parla Branding",
    "url": "https://www.parlabranding.dk",
    "review": testimonials.map(testimonial => ({
      "@type": "Review",
      "reviewBody": testimonial.text,
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": testimonial.rating,
        "bestRating": 5,
        "worstRating": 1
      },
      "author": {
        "@type": "Person",
        "name": testimonial.name
      },
      "publisher": {
        "@type": "Organization",
        "name": "Parla Branding"
      }
    })),
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": 4.8,
      "reviewCount": testimonials.length,
      "bestRating": 5,
      "worstRating": 1
    }
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <svg
        key={i}
        className={`star ${i < rating ? 'filled' : ''}`}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
      </svg>
    ));
  };

  return (
    <section className={`testimonials ${className}`.trim()} id="testimonials">
      {/* Schema markup for SEO */}
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(testimonialsSchema) }}
      />
      
      <div className="container">
        <div className="testimonials-header">
          <h2 className="testimonials-title">
            Hvad siger vores partnere?
          </h2>
        </div>

        <div className="testimonials-marquee">
          <div 
            ref={trackRef}
            className="testimonials-track"
            style={{ transform: 'translateX(0px)' }}
          >
            {duplicatedTestimonials.map((testimonial, index) => (
              <div key={`${testimonial.id}-${index}`} className="testimonial-card">
                <div className="testimonial-content">
                  <div className="testimonial-rating">
                    {renderStars(testimonial.rating)}
                  </div>
                  
                  <p className="testimonial-text">
                    "{testimonial.text}"
                  </p>
                  
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div className="author-info">
                      <h4 className="author-name">{testimonial.name}</h4>
                      <p className="author-company">{testimonial.company}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="testimonials-bottom-section">
          <div className="testimonials-overall-rating">
            <div className="overall-rating-stars">
              <svg className="star filled" width="20" height="20" viewBox="0 0 24 24" fill="#FFD700" stroke="none">
                <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
              </svg>
              <svg className="star filled" width="20" height="20" viewBox="0 0 24 24" fill="#FFD700" stroke="none">
                <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
              </svg>
              <svg className="star filled" width="20" height="20" viewBox="0 0 24 24" fill="#FFD700" stroke="none">
                <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
              </svg>
              <svg className="star filled" width="20" height="20" viewBox="0 0 24 24" fill="#FFD700" stroke="none">
                <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
              </svg>
              <svg className="star partial" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="none">
                <defs>
                  <linearGradient id="partialFill" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="40%" stopColor="#FFD700" />
                    <stop offset="40%" stopColor="#E5E5E5" />
                  </linearGradient>
                </defs>
                <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" fill="url(#partialFill)" />
              </svg>
            </div>
            <div className="overall-rating-text">
              <span className="rating-score">4,4</span>
              <span className="rating-out-of">ud af 5 stjerner</span>
            </div>
          </div>

          <div className="testimonials-cta">
            {!hideCasesButton ? (
              <CTAKnap 
                variant="primary" 
                size="large"
                href="/cases"
                icon={<CTAIkoner.BarChart />}
              >
                Se vores cases
              </CTAKnap>
            ) : (
              alternativeCasesButton
            )}
            {!hideOmOsButton && (
              <CTAKnap 
                variant="outline" 
                size="large"
                href="/omos"
                icon={<CTAIkoner.FileText />}
              >
                Mød os
              </CTAKnap>
            )}
            {customSecondButton && customSecondButton}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
